module.exports = __webpack_public_path__ + "static/高新技术企业证书-30667b65fa52bff83dfe03e34ad57f47.jpg";